import {useMutation} from 'react-query';
import {AxiosError} from 'axios';
import getCalculateLoan, {
  ICalculateLoanResponse,
  IGetCalculateLoanParams,
} from '.';

interface IUseGetCalculateLoanProps {
  onSuccess?: (data: any) => void;
}

const useGetCalculateLoan = ({onSuccess}: IUseGetCalculateLoanProps = {}) => {
  const {mutate, data, isLoading, isError, error} = useMutation<
    ICalculateLoanResponse,
    AxiosError,
    IGetCalculateLoanParams
  >({
    mutationFn: (params: IGetCalculateLoanParams) => getCalculateLoan(params),

    onSuccess: data => {
      onSuccess?.(data);
    },
  });

  return {mutate, data, isLoading, isError, error};
};

export default useGetCalculateLoan;
